import { Button, Drawer, Form, Grid, Image, InputNumber, Typography } from 'antd';
import defaultAvatar from 'assets/images/default-avatar.jpg';
import { useEffect } from 'react';
import { IVariant } from 'services/variant';

interface ProductEditDrawerProps {
  variant: IVariant;
  visible: boolean;
  onUpdate: (data: IVariant) => void;
  onClose: () => void;
}

export const ProductEditDrawer: React.FC<ProductEditDrawerProps> = ({
  variant,
  visible,
  onUpdate,
  onClose,
}) => {
  const [form] = Form.useForm();
  const breakpoint = Grid.useBreakpoint();
  const isMobile = !breakpoint.sm;

  useEffect(() => {
    form.setFieldsValue({
      purchasePrice: variant.purchasePrice,
      sellingPrice: variant.sellingPrice,
    });
  }, [form, variant]);

  const handleSubmit = (values: any) => {
    const updatedVariantData = {
      ...variant,
      purchasePrice: Number(values.purchasePrice),
      sellingPrice: Number(values.sellingPrice),
    };

    onUpdate(updatedVariantData);
    onClose();
  };

  return (
    <Drawer
      title="Edit Product"
      visible={visible}
      onClose={onClose}
      width={isMobile ? '100%' : 420}
      bodyStyle={{ paddingBottom: isMobile ? 24 : 88 }}
      footer={
        isMobile ? null : (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            gap: 8,
          }}
        >
          <Button onClick={onClose} style={{ flex: isMobile ? '1 1 100%' : undefined }}>
            Cancel
          </Button>
          <Button
            onClick={form.submit}
            type="primary"
            style={{ flex: isMobile ? '1 1 100%' : undefined }}
          >
            Save
          </Button>
        </div>
        )
      }
    >
      <Form form={form} layout="vertical" name="edit_variant" onFinish={handleSubmit}>
        <Form.Item style={{ textAlign: 'center' }}>
          <Image
            src={variant.productVariantPhoto?.url || defaultAvatar}
            alt={variant.productVariantName}
            width={150}
            height={150}
            style={{
              objectFit: 'cover',
              borderRadius: '4px',
              display: 'block',
              margin: '0 auto',
            }}
          />
        </Form.Item>

        <Form.Item label="Product Name">
          <Typography.Text>{variant.productVariantName}</Typography.Text>
        </Form.Item>

        <Form.Item label="SKU">
          <Typography.Text>{variant.sku}</Typography.Text>
        </Form.Item>

        <Form.Item
          name="purchasePrice"
          label="Purchase Price"
          rules={[
            {
              required: true,
              message: 'Please enter the purchase price!',
            },
          ]}
        >
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name="sellingPrice"
          label="Selling Price"
          rules={[
            {
              required: true,
              message: 'Please enter the selling price!',
            },
          ]}
        >
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>

        {isMobile && (
          <Form.Item style={{ marginBottom: 0 }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                marginTop: 8,
              }}
            >
              <Button onClick={onClose} block>
                Cancel
              </Button>
              <Button onClick={form.submit} type="primary" block>
                Save
              </Button>
            </div>
          </Form.Item>
        )}
      </Form>
    </Drawer>
  );
};
